import React, { useState } from 'react';
import { Card, Button, Form, Grid, Tab, Tabs } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import { useError } from "../../state/error";
import postObject from '../../lib/postObject';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import AddProducts from './shipment-create-add-product';
import GoogleMap from '../../components/googleMap';
const shipmentTypes = [
  { label: "Shipment Only", value: "ShipmentOnly" },
  { label: "Prime Shipment", value: "PrimeShipment" },
  { label: "Purchase & Ship", value: "PurchaseAndShip" }
]
const ShipmentCreateModal = ({ closeMainModal, reload }) => {
  const [saveLoading, toggleSaveLoading] = useState(false)
  const { pathname } = useLocation()
  const { setIsError } = useError();
  const [form, changeFormInput] = useState({
    name: '',
    shipmentType: shipmentTypes.find(s => s.value === pathname.split('shipments/')[1]) || shipmentTypes[0],
    fromCountry: null,
    toCountry: null,
    fromCity: null,
    toCity: null,
    owner: null,
    shipmentArrivalDate: null,
    meetingPoint: null,
    isHomeDelivery: false
  });
  const { data: users, loading: usersLoading } = useFetch(`users`);
  const { data: countries, loading: countriesLoading } = useFetch(`countries`);
  const { data: fromCities, loading: fromCitiesLoading } = useFetch(`cities?countryId=${form.fromCountry && form.fromCountry.value}`);
  const { data: toCities, loading: toCitiesLoading } = useFetch(`cities?countryId=${form.toCountry && form.toCountry.value}`);
  const [products, setProducts] = useState([])
  const saveProduct = (product) => {
    const { category, subcategory, ...trimmed } = product
    const newProduct = {
      subCategoryId: subcategory.value,
      ...trimmed,
    }
    setProducts(p => [...p, newProduct])
  }
  const editProduct = (index, editedProduct) => {
    let tmp = products
    tmp[index] = editedProduct
    setProducts([...tmp])
  }
  const deleteProduct = (index) => {
    let tmp = products
    tmp.splice(index, 1)
    setProducts([...tmp])
  }

  // Debug function to check current form state
  const debugFormState = () => {
    console.log('=== FORM DEBUG INFORMATION ===');
    console.log('Form State:', form);
    console.log('Products Count:', products.length);
    console.log('Products:', products);
    console.log('Missing Fields Analysis:');
    console.log('- Name:', form.name ? '✓ Filled' : '✗ Missing');
    console.log('- User:', form.owner ? '✓ Filled' : '✗ Missing');
    console.log('- Shipment Type:', form.shipmentType ? '✓ Filled' : '✗ Missing');
    console.log('- Arrival Date:', form.shipmentArrivalDate ? '✓ Filled' : '✗ Missing');
    console.log('- From Country:', form.fromCountry ? '✓ Filled' : '✗ Missing');
    console.log('- From City:', form.fromCity ? '✓ Filled' : '✗ Missing');
    console.log('- To Country:', form.toCountry ? '✓ Filled' : '✗ Missing');
    console.log('- To City:', form.toCity ? '✓ Filled' : '✗ Missing');
    console.log('- Meeting Point:', form.meetingPoint ? '✓ Filled' : '✗ Missing');
    console.log('- Products:', products.length > 0 ? `✓ ${products.length} products` : '✗ No products');
    console.log('=== END DEBUG INFORMATION ===');
  };
  const submitShipment = () => {
    // Debug: Log current form state
    console.log('Form validation debug:', {
      form,
      productsCount: products.length,
      missingFieldsCheck: {
        name: !form.name,
        owner: !form.owner,
        shipmentArrivalDate: !form.shipmentArrivalDate,
        fromCountry: !form.fromCountry,
        fromCity: !form.fromCity,
        toCountry: !form.toCountry,
        toCity: !form.toCity,
        meetingPoint: !form.meetingPoint,
        products: products.length === 0
      }
    });

    const missingFields = [];
    
    if (!form.name) missingFields.push('Name');
    if (!form.owner) missingFields.push('User');
    if (!form.shipmentArrivalDate) missingFields.push('Arrival Date');
    if (!form.fromCountry) missingFields.push('From Country');
    if (!form.fromCity) missingFields.push('From City');
    if (!form.toCountry) missingFields.push('To Country');
    if (!form.toCity) missingFields.push('To City');
    if (!form.meetingPoint) missingFields.push('Meeting Point');
    if (products.length === 0) missingFields.push('Products (at least one product required)');

    if (missingFields.length > 0) {
      const errorMessage = `Please fill the following required fields: ${missingFields.join(', ')}`;
      setIsError(errorMessage);
      return;
    }
    const tmp = {
      fromCity: {
        cityId: form.fromCity.value['_id'],
        name: form.fromCity.value['name'],
        countryId: form.fromCity.value.countryId,
        countryName: form.fromCountry.label
      },
      toCity: {
        cityId: form.toCity.value['_id'],
        name: form.toCity.value['name'],
        countryId: form.toCity.value.countryId,
        countryName: form.toCountry.label
      },
      products: products,
      isHomeDelivery: form.isHomeDelivery
    }
    const shipment = {
      name: form.name,
      shipmentType: form.shipmentType.value,
      shipmentArrivalDate: new Date(form.shipmentArrivalDate).toLocaleString(),
      owner: {
        userId: form.owner.value['_id'],
        username: form.owner.value.username
      },
      meetingPoint: form.meetingPoint,
      price: tmp,
      ...tmp
    }
    
    toggleSaveLoading(true)
    postObject('shipments', shipment).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    })
  }
  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Shipment</Card.Title>
        <Card.Options>
          <Button size="sm" icon="x" onClick={() => closeMainModal()} />
        </Card.Options>
      </Card.Header>
      <Card.Body className="noPaddingTop">
        <Tabs initialTab="Shipment Details">
          <Tab title="Shipment Details">
            <Grid>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Input
                    name='name'
                    label='Name: *'
                    placeholder=''
                    value={form.name}
                    onChange={(e) => { changeFormInput({ ...form, name: e.target.value }) }}
                  />
                  <Form.Label>User: *</Form.Label>
                  <Select
                    value={form.owner}
                    options={users && users.map(user => {
                      return ({ label: user.email, value: user });
                    })}
                    isSearchable
                    placeholder="user"
                    isLoading={usersLoading}
                    onChange={(e) => { changeFormInput({ ...form, owner: e }); }}
                  />
                </Grid.Col>
                <Grid.Col width={6}>
                  <Form.Label>Shipment Type: *</Form.Label>
                  <Select
                    value={form.shipmentType}
                    options={shipmentTypes}
                    placeholder="Shipment Type"
                    onChange={(e) => { changeFormInput({ ...form, shipmentType: e }); }}
                    className="mb-4"
                  />

                  <Form.Label>Arrival Date: *</Form.Label>
                  <input
                    type="datetime-local"
                    onChange={(e) => { changeFormInput({ ...form, shipmentArrivalDate: e.target.value }) }}
                    value={form.shipmentArrivalDate || ''}
                    className="form-control"
                  />
                </Grid.Col>
              </Grid.Row>

              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Label>From Country: *</Form.Label>
                  <Select
                    isLoading={countriesLoading}
                    value={form.fromCountry}
                    onChange={(e) => { changeFormInput({ ...form, fromCity: null, fromCountry: e }); }}
                    options={countries && countries.map(country => {
                      return ({ label: country.name, value: country['_id'] });
                    })}
                  />
                  <div className="pt-1" />
                  <Form.Label>From City: *</Form.Label>
                  <Select
                    isLoading={fromCitiesLoading}
                    value={form.fromCity}
                    onChange={(e) => { changeFormInput({ ...form, fromCity: e }) }}
                    options={fromCities && fromCities.map(city => {
                      return ({ label: city.name, value: city });
                    })}
                  />
                </Grid.Col>

                <Grid.Col width={6}>
                  <Form.Label>To Country: *</Form.Label>
                  <Select
                    isLoading={countriesLoading}
                    value={form.toCountry}
                    onChange={(e) => { changeFormInput({ ...form, toCity: null, toCountry: e }); }}
                    options={countries && countries.map(country => {
                      return ({ label: country.name, value: country['_id'] });
                    })}
                  />
                  <div className="pt-1" />
                  <Form.Label>To City: *</Form.Label>
                  <Select
                    isloading={toCitiesLoading}
                    value={form.toCity}
                    onChange={(e) => { changeFormInput({ ...form, toCity: e }) }}
                    options={toCities && toCities.map(city => {
                      return ({ label: city.name, value: city });
                    })}
                  />
                </Grid.Col>
              </Grid.Row>

              <Form.Label>Home Delivery?</Form.Label>
              <input type="checkbox" checked={form.isHomeDelivery} onChange={(e) => changeFormInput({ ...form, isHomeDelivery: e.target.checked })} />
            </Grid>
          </Tab>

          <Tab title={`Add Products ${products.length === 0 ? '*' : ''}`}>
            <AddProducts products={products} saveProduct={saveProduct} editProduct={editProduct}
              deleteProduct={deleteProduct} />
          </Tab>

          <Tab title={`Add Meeting Point ${!form.meetingPoint ? '*' : ''}`}>
            <GoogleMap saveMeetingPoint={(point) => changeFormInput({ ...form, meetingPoint: point })} />
          </Tab>
        </Tabs>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="warning"
            size="sm"
            className="ml-2"
            onClick={debugFormState}
            disabled={saveLoading}
          >
            Debug Form
          </Button>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={() => submitShipment()}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            outline
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={() => closeMainModal(false)}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  )
}

export default ShipmentCreateModal;